import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardApiAccessRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardApiAccessContainerLoadable } from './OrgDashboardApiAccessContainerLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardApiAccessRoute>,
) {
  await OrgDashboardApiAccessContainerLoadable.load();
}

export default function OrgDashboardApiAccessHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('API Documentation and Sandbox')}>
      <OrgDashboardApiAccessContainerLoadable />
    </RouteModule>
  );
}
